var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { Prop, Emit } from "vue-property-decorator";
import DistributionPattern from "~/components/distribution-common/distribution-pattern.vue";
import { namespace } from "vuex-class";
import { CASE_CHANNEL } from "~/config/enum.config";
import { VisitCaseManageService } from "~/services/domain-service/visit-case-manage.service";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
import { CaseAssitVisitStayService } from "~/services/domain-service/case-assist-visit-stay.service";
import { CaseAssitCaseService } from "~/services/domain-service/case-assist-case.service";
import { CaseAssistAntiFraudCaseStayService } from "~/services/domain-service/case-assist-anti-fraud-case-stay.service";
import { CaseAssistService } from "~/services/domain-service/case-assist.service";
var AllotModule = namespace("case-allot");
var Distribution = /** @class */ (function (_super) {
    __extends(Distribution, _super);
    function Distribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 确定按钮loading
        _this.submitLoading = false;
        /**
         * table数据源
         */
        _this.dataSet = [];
        return _this;
    }
    /**
     * 获取预览数据
     */
    Distribution.prototype.refreshData = function () {
        switch (this.fromChannel) {
            case CASE_CHANNEL.tel:
            case CASE_CHANNEL.assist_tel:
                this.telCaseManageService
                    .reviewDistributeCase(this.perviewModel)
                    .subscribe(this.updatePreViewData);
                break;
            case CASE_CHANNEL.legal:
            case CASE_CHANNEL.assist_legal:
                this.legalCaseManageService
                    .reviewDistributeCase(this.perviewModel)
                    .subscribe(this.updatePreViewData);
                break;
            case CASE_CHANNEL.visit:
            case CASE_CHANNEL.assist_visit:
                this.visitCaseManageService
                    .reviewDistributeCase(this.perviewModel)
                    .subscribe(this.updatePreViewData);
                break;
            case CASE_CHANNEL.law:
                this.caseAssitVisitStayService
                    .synergisticDistribution(this.perviewModel)
                    .subscribe(this.updatePreViewData);
                break;
            case CASE_CHANNEL.fraud:
                this.caseAssistAntiFraudCaseStayService
                    .previewCaseAssist(this.perviewModel)
                    .subscribe(this.updatePreViewData);
                break;
        }
    };
    Distribution.prototype.emitSuccess = function () {
        this.$message.success('分案成功');
        this.dataSet = [];
        this.submitLoading = false;
        this.emitClose();
    };
    Distribution.prototype.emitBack = function () { };
    Distribution.prototype.emitClose = function () { };
    Object.defineProperty(Distribution.prototype, "isCustomerDistribution", {
        /**
         * 是否自定义分配
         */
        get: function () {
            return this.mode === "BY_CUSTOMIZE";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Distribution.prototype, "inputMax", {
        /**
         * 输入框最大值
         */
        get: function () {
            return this.perviewModel.caseIds.length;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 计算输入后当前行人员的案件总数
     */
    Distribution.prototype.computAllotCaseCount = function (row) {
        var inputNum = Number.parseInt(row.num || "0");
        return inputNum + row.currentNum;
    };
    /**
     * 输入验证
     */
    Distribution.prototype.onNumBlur = function (e) {
        if (e.target.valueAsNumber > this.inputMax) {
            this.$message.error(e.target.validationMessage);
        }
        else {
            var alreadySum = this.dataSet.reduce(function (a, c) { return a + Number.parseInt(c.num || "0"); }, 0);
            if (alreadySum > this.inputMax) {
                this.$message.error("输入数量不能大于选中分案数量");
            }
        }
    };
    /**
     * 更新预览数据
     */
    Distribution.prototype.updatePreViewData = function (data) {
        this.dataSet = data.resDistModel;
        this.distributeModel.analyseId = data.analyseId;
    };
    /**
     * 确定分配
     */
    Distribution.prototype.submit = function () {
        var _this = this;
        this.submitLoading = true;
        this.distributeModel.distributeNumber = this.dataSet.map(function (v) { return v.num; });
        var service = null;
        switch (this.fromChannel) {
            case CASE_CHANNEL.tel:
                service = this.telCaseManageService;
                break;
            case CASE_CHANNEL.legal:
                service = this.legalCaseManageService;
                break;
            case CASE_CHANNEL.visit:
                service = this.visitCaseManageService;
                break;
            case CASE_CHANNEL.assist_tel:
            case CASE_CHANNEL.assist_visit:
            case CASE_CHANNEL.assist_legal:
                service = this.caseAssistService;
                break;
            case CASE_CHANNEL.law:
                service = this.caseAssitVisitStayService;
                break;
            case CASE_CHANNEL.fraud:
                service = this.caseAssistAntiFraudCaseStayService;
                break;
        }
        if (!service)
            return;
        service
            .confirmDistributeCase(this.distributeModel)
            .subscribe(this.emitSuccess, function () { _this.$message.error('分案失败'); _this.submitLoading = false; });
    };
    __decorate([
        Dependencies(PageService)
    ], Distribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(VisitCaseManageService)
    ], Distribution.prototype, "visitCaseManageService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], Distribution.prototype, "telCaseManageService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], Distribution.prototype, "legalCaseManageService", void 0);
    __decorate([
        Dependencies(CaseAssitVisitStayService)
    ], Distribution.prototype, "caseAssitVisitStayService", void 0);
    __decorate([
        Dependencies(CaseAssitCaseService)
    ], Distribution.prototype, "caseAssitCaseService", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudCaseStayService)
    ], Distribution.prototype, "caseAssistAntiFraudCaseStayService", void 0);
    __decorate([
        Dependencies(CaseAssistService)
    ], Distribution.prototype, "caseAssistService", void 0);
    __decorate([
        AllotModule.State
    ], Distribution.prototype, "mode", void 0);
    __decorate([
        AllotModule.Getter
    ], Distribution.prototype, "perviewModel", void 0);
    __decorate([
        AllotModule.Getter
    ], Distribution.prototype, "distributeModel", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Distribution.prototype, "fromChannel", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Distribution.prototype, "again", void 0);
    __decorate([
        Emit("success")
    ], Distribution.prototype, "emitSuccess", null);
    __decorate([
        Emit("back")
    ], Distribution.prototype, "emitBack", null);
    __decorate([
        Emit("close")
    ], Distribution.prototype, "emitClose", null);
    Distribution = __decorate([
        Component({
            components: {
                DistributionPattern: DistributionPattern
            }
        })
    ], Distribution);
    return Distribution;
}(Vue));
export default Distribution;
